import React from 'react';
import { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

const Title: ComponentType<HTMLAttributes<HTMLSpanElement>>  = styled('span')`
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 42px;

  color: #42526E;

  max-width: 600px;

  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;

  align-items: center;

  padding: 0px 20px;

  height: 42px;

  background-color: #FAFAFA;
  
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: #DFE1E6;
  border-radius: 8px 8px 0px 0px;

  display: block;
  margin: 0 auto;
  width: fit-content;
  pointer-events: auto;

  overflow-x: clip;
  text-overflow: ellipsis;
  text-wrap: nowrap;
`;

const Container: ComponentType<HTMLAttributes<HTMLDivElement>>  = styled('div')({
  position: 'fixed',
  top: '18px',
  width: '100%',
  pointerEvents: 'none'
});

export default (props: HTMLAttributes<HTMLSpanElement>) => {
  return <Container>
    <Title {...props}/>
  </Container>
};